<template>
  <div>
    <v-radio-group v-if="fragment.type === 'RA'" :value="fragmentValue" :disabled="isDeactivate || isConfirmed" row>
      <v-radio v-for="option in fragment.options"
               :value="option.value" :key="option.id" style="margin-bottom: 7px;"
               @click="updateValue(option.value, false)">
        <template slot="label">
          <span @click="updateValue(option.value, true)" :disabled="isDeactivate || isConfirmed">{{
              option.value
            }}</span>
        </template>
      </v-radio>
    </v-radio-group>

    <v-radio-group v-if="fragment.type === 'CK'" :disabled="isDeactivate || isConfirmed" row>
      <v-checkbox v-for="option in fragment.options" v-model="fragmentValue"
                  :label="option.value" :value="option.value"
                  @click.stop="updateValue(option.value, false)">
      </v-checkbox>
    </v-radio-group>

    <v-select
      v-if="fragment.type === 'SL'"
      v-model="selectedItem"
      item-text="value"
      :items="items"
      :disabled="isDeactivate || isConfirmed"
      :background-color="backgroundColor"
      outline
      solo
      @change="updateValue(selectedItem, false)">
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'FragmentOption',
  props: {
    fragment: Object,
    isDeactivate: {
      type: Boolean,
      default: false
    },
    isConfirmed: Boolean,
  },
  data () {
    return {
      selectedItem: {value: '選択して下さい'}
    }
  },
  computed: {
    items () {
      return [{value: '選択して下さい'}].concat(this.fragment.options)
    },
    fragmentValue () {
      if (!this.fragment) return ''
      return this.fragment.value
    },
    backgroundColor () {
      /**
       * 背景色の変更
       */
      if (this.isConfirmed) {
        return '#D3D3D3'
      } else if (this.isDeactivate) {
        return '#f5f5f5'
      }
      return undefined
    },
  },
  methods: {
    updateValue (clickedValue, isLabelClicked) {
      if (this.fragment.type === 'RA') {
        if (this.fragment.value === clickedValue && !isLabelClicked) {
          this.$emit('updateFragment', null)
        } else {
          this.$emit('updateFragment', clickedValue)
        }
      } else if (this.fragment.type === 'CK') {
        if (this.fragment.value.includes(clickedValue)) {
          let filteredOptions = this.fragment.value.filter(
            option => option !== clickedValue
          )
          this.$emit('updateFragment', filteredOptions)
        } else {
          let updatedValue = [...this.fragment.value]
          updatedValue.push(clickedValue)
          this.$emit('updateFragment', updatedValue)
        }
      } else if (this.fragment.type === 'SL') {
        if (clickedValue === '選択して下さい') {
          this.$emit('updateFragment', null)
        } else {
          this.$emit('updateFragment', clickedValue)
        }
      }
    }
  }
}
</script>

<style scoped>
.v-input--radio-group .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 0;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-top: 4px;
  margin-right: 12px;
}
</style>
